angular.module('component-authentication', [])
	.service('Authentication', AuthenticationService);

AuthenticationService.$inject = ['$window', '$rootScope', '$q', '$timeout', '$state', 'PortalApi','Notification', 'Storage', 'Localization'];
function AuthenticationService($window, $rootScope, $q, $timeout, $state, PortalApi, Notification, Storage, Localization) {
	var tmpRegData = {};

	var body = angular.element(document.body);

	var Authentication = {
		user: {},
		showRestricted: false,
		frameLogin: '',
		toMain: function () {
			$state.go(Authentication.showRestricted ? 'pages.history' : 'pages.main');
		},
		updateSessionTimer: function () {
			if (Authentication.isLogged) {
				Helper.sessionTimeEnd = +new Date() + Helper.sessionTime - Helper.interval;

				if (!Helper.intervalId) {
					Helper.intervalId = setInterval(function () {
						if (+new Date() >= Helper.sessionTimeEnd) {
							Authentication.logout(true);
						}
					}, Helper.interval);
				}
			}
		},
		sessionStart: function (force) {
			var defer = $q.defer();
			force = !!force || false;

			if (!force && (Helper.isLogged() || Helper.getSession() != void(0))) {
				defer.resolve();
			} else if (!Helper.sessionStartPromise) {

				Helper.sessionStartPromise = defer.promise;

				PortalApi.sessionStart({
					frameLogin: Authentication.frameLogin
				}).then(function (res) {
					Helper.setSession(res.token);
					Helper.sessionStartPromise = null;

					if (res.authorized) {
                        Helper.setToken(res.token);
                        Helper.updateUser(res);
		                Helper.setMpStatus(res.mp_status);

                        Authentication.showRestricted = true;
                        Notification.clearAll();

                        $rootScope.$broadcast('login');

						// res.redirect = "mycards"

                        // if(typeof res.redirect == 'object'){
						// 	var temp;
						// 	if (res.redirect.status == 'otp') {
						// 		temp = true;
						// 	} else {
						// 		temp = false;
						// 	}
						//
                        //     $state.go('pages.'+res.redirect.page, {
						// 		otp: temp
						// 	}).then(function () {
                        //         $rootScope.STATE_GOIN = false;
                        //         window.scrollTo(0,0);
                        //     });
                        // }
						if (res.redirect) {
							$state.go('pages.mycards').then(function () {
								$rootScope.STATE_GOIN = false;
								window.scrollTo(0,0);
							});
						}
					}

					if(res.redirect){
                        if(res.redirect.payment_id && res.redirect.page == 'payment') {
                            PortalApi.getPaymentDataById(res.redirect.payment_id).then(function (paymentData) {
                                $state.go('pages.payment', {
                                    amount: paymentData.amount,
                                    notify: {
                                        type: res.redirect.message_type || '',
                                        mssg: res.redirect.message_type + '.' + res.redirect.message_code || ''
                                    },
                                    serviceId: paymentData.service_id,
                                    url: paymentData.service_id,
                                    fields: paymentData.check_fields || {},
                                    createFields: paymentData.creating_fields || {},
                                    infoState: res.redirect.state || '',
                                    autoCheck: true,
                                    templateId: false,
                                });
                            });
                        }
					}


					defer.resolve(res.token);
				});
			}

			return Helper.sessionStartPromise || defer.promise
		},
        setAuthHeader: function (headers, token) {
            var token = token || Authentication.getToken();

            if (token) {
                headers['User-Token'] = token;
            }
        },
		httpMethod: function (operation, headers) {
			headers['X-HTTP-Method-Override'] = operation;
		},
		login: function (form) {
			var defer = $q.defer();
			body.find(".load").removeClass("hide");

			PortalApi.userLogin(form).then(function (user) {
				Helper.setToken(user.token);
				Helper.setSession(user.token);
                Helper.updateUser(user);
                Helper.setMpStatus(user.mp_status);

				Authentication.showRestricted = true;
				Authentication.updateSessionTimer();
				Notification.clearAll();

				//Google tag manager
				if (Array.isArray($window.dataLayer)) {
					$window.dataLayer.push({
						'userID': user.user_id
					});
				}

				$rootScope.$broadcast('login');

				return defer.resolve();
			}).catch(function (reason) {
				return defer.reject();
			}).finally(function () {
				body.find(".load").addClass("hide");
			});

			return defer.promise
		},
		logout: function (sessionExpire) {
            var defer = $q.defer();
			var body = angular.element(document.body);
			body.find(".load").removeClass("hide");

			sessionExpire = !!sessionExpire || false;

			if (!Helper.logoutPromise) {

				Helper.logoutPromise = defer.promise;

				PortalApi.userLogout().then(function (data) {

					if (sessionExpire) {
                        Localization.notifyTemplate('error', 'ERRORS.SESSION_EXPIRED', 5, true);
					}

					Helper.clearSeesionInterval();
					Helper.removeToken();
	                Helper.removeMpStatus();
					Helper.setSession(data.token);

					Authentication.showRestricted = false;
					Helper.logoutPromise = null;
                    Helper.clearUser();

					if (Array.isArray($window.dataLayer)) {
						$window.dataLayer.forEach(function (value, i) {
							if (value.userID) {
								$window.dataLayer.splice(i, 1);
							}
						});
					}

					$rootScope.$broadcast('logout');
					$state.go('pages.main');

					return defer.resolve();
				}).catch(function (reason) {
					return defer.reject();
				}).finally(function () {
					body.find(".load").addClass("hide");
				})
			}

			return Helper.logoutPromise || defer.promise;
		},
		getToken: function () {
			return Helper.getSession();
		},
        removeSession: function () {
            return Storage.clear();
        },
	};

	Object.defineProperty(Authentication, 'isLogged', {
		get: function () {
			return Helper.isLogged();
		},
		set: function () {
			return Helper.isLogged();
		},
		configurable: true
	});

	Object.defineProperty(Authentication, 'session', {
		get: function () {
			return Helper.isSessionStart();
		},
		set: function () {
			return Helper.isSessionStart();
		},
		configurable: true
	});

	var Helper = {
		sessionStartPromise: null,
		logoutPromise: null,
		intervalId: 0,
		sessionTime: 15 * 60 * 1000,
		interval: 1000,
		sessionTimeEnd: 0,
		user: {
            name: '',
            email: '',
            phone: '',
            user_id: '',
			mp_status: ''
        },
		clearUser: function () {
            Authentication.user = angular.copy(Helper.user);
            Storage.removeItem('user');
		},
		updateUser: function (user) {
			Helper.clearUser();

			Object.keys(Helper.user).forEach(function (key) {
                Authentication.user[key] = user[key];
			});

            Storage.setItem('user', JSON.stringify(Authentication.user));
		},
		clearSeesionInterval: function () {
			clearInterval(Helper.intervalId);
			Helper.intervalId = 0;
			Helper.sessionTimeEnd = 0;
		},
		isLogged: function () {
			var flag = !!this.getToken();
			var user;

			try {
				user = JSON.parse(Storage.getItem('user'));
			} catch (e) {}

			if (flag && typeof(user) == 'object') {
				Authentication.user = user;
				Authentication.showRestricted = true;
			}

			return flag;
		},
		isSessionStart: function () {
			return !!this.getSession();
		},
		setSession: function (session) {
			return Storage.setItem('session', session);
		},
		getSession: function () {
			return Storage.getItem('session');
		},
		setToken: function (token) {
			return Storage.setItem('token', token);
		},
		getToken: function () {
			return Storage.getItem('token');
		},
		removeToken: function () {
			return Storage.removeItem('token');
		},
		setMpStatus: function (mp_status) {
			return Storage.setItem('mp_status', mp_status);
		},
		removeMpStatus: function () {
			return Storage.removeItem('mp_status');
		},
	};

	Authentication.getRegData = function (data) {
		var regData = [];
		var info = null;

		try {
			var tmp = Storage.getItem('registrationData');

			if (tmp) {
				regData = JSON.parse(tmp);
			}
		} catch (e) {

		}

		if (data && data.mail) {
			regData.forEach(function (user) {

				if (user.mail === data.mail) {
					info = user;
				}
			});
		}

		return data ? info : regData;
	};

	Authentication.setRegData = function (data) {
		var regData = Authentication.getRegData();

		delete data.agreement;
		regData.push(data);

		Storage.setItem('registrationData', JSON.stringify(regData));
	};

	Authentication.getUser = function () {
		var userData = Storage.getItem('user');

		if (userData) {
			try {
				if (userData) {
                    userData = JSON.parse(Storage.getItem('user'));
				}
			} catch (err) {
                userData = null;
			}
		}

		return userData;
	};

	return Authentication;
}

module.exports = 'component-authentication';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/authentication/index.js
 ** module id = 72
 ** module chunks = 1
 **/